import {
    Box,
    CrudMode,
    Checkbox,
    DataDisplay,
    Grid,
    pn,
    Stack,
    Typography,
    useElementBreakpoints,
    ValidationErrors,
} from "@compass/core";

import { Input } from "components";
import { Iep, IEPEditResource, IEPViewResource } from "generated/openApi";
import produce from "immer";
import React from "react";

export const IEPPageBody = (props: {
    crudMode: CrudMode;
    iep: Iep;
    setIep: (value: Iep) => void;
    viewResource: IEPViewResource;
    editResource: IEPEditResource;
    validationErrors: ValidationErrors;
}) => {
    const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
    const properties = props.viewResource.properties || [];

    const nameField = () => {
        const propertyName = pn<Iep>("name");
        const property = properties.find((x) => x.propertyName === propertyName);
        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.iep.name}</DataDisplay>
        ) : (
            <Input
                modelProperty={property}
                errors={props.validationErrors[propertyName]}
                value={props.iep.name}
                onChange={(e) =>
                    props.setIep(
                        produce(props.iep, (draft) => {
                            draft.name = e.target.value;
                        })
                    )
                }
            />
        );
    };

    const isIepField = () => {
        const propertyName = pn<Iep>("isIep");
        const property = properties.find((x) => x.propertyName === propertyName);
        return props.crudMode === "view" ? (
            <DataDisplay label={property?.displayName}>{props.iep.isIep ? "Yes" : "No"}</DataDisplay>
        ) : (
            <Checkbox
                label={property?.displayName}
                checked={props.iep.isIep || false}
                onChange={(e) =>
                    props.setIep(
                        produce(props.iep, (draft) => {
                            draft.isIep = e.target.checked;
                        })
                    )
                }
            />
        );
    };

    return (
        <Grid ref={breakpointsRef} container spacing="sm">
            <Grid item xs={largeFieldBreakpoints}>
                {nameField()}
            </Grid>
            <Grid item xs={largeFieldBreakpoints}>
                {isIepField()}
            </Grid>
        </Grid>
    );
};